export type CandidateType = 'host' | 'srflx' | 'prflx' | 'relay' | 'unknown';
export type ConnectionPath = 'direct' | 'relay' | 'unknown';
export type QualityLimitationReason = 'none' | 'cpu' | 'bandwidth' | 'other' | 'unknown';

export interface CodecMetrics {
  readonly mimeType: string;
  readonly payloadType: number | null;
  readonly clockRate: number | null;
  readonly channels: number | null;
  readonly sdpFmtpLine: string | null;
}

export interface SelectedCandidatePairMetrics {
  readonly id: string;
  readonly localCandidateId: string | null;
  readonly remoteCandidateId: string | null;
  readonly state: string | null;
  readonly nominated: boolean | null;
  readonly protocol: string | null;
  readonly relayProtocol: string | null;
}

export interface ConnectionMetrics {
  readonly collectedAt: number;
  readonly sampleDurationMs: number | null;
  readonly rttMs: number | null;
  readonly packetsSent: number | null;
  readonly packetsLost: number | null;
  readonly packetLossPercentage: number | null;
  readonly jitterMs: number | null;
  readonly outboundBitrateBps: number | null;
  readonly availableOutgoingBitrateBps: number | null;
  readonly framesEncoded: number | null;
  readonly framesSent: number | null;
  readonly framesDropped: number | null;
  readonly fps: number | null;
  readonly frameWidth: number | null;
  readonly frameHeight: number | null;
  readonly qualityLimitationReason: QualityLimitationReason | null;
  readonly codec: CodecMetrics | null;
  readonly selectedCandidatePair: SelectedCandidatePairMetrics | null;
  readonly localCandidateType: CandidateType | null;
  readonly remoteCandidateType: CandidateType | null;
  readonly connectionPath: ConnectionPath;
  readonly retransmittedPacketsSent: number | null;
  readonly retransmittedBytesSent: number | null;
}

export type StatsCollectorState = 'idle' | 'running' | 'stopped' | 'destroyed';

export class StatsCollectorError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'StatsCollectorError';
  }
}

export interface StatsCollectorEvents {
  readonly metrics: { readonly metrics: ConnectionMetrics };
  readonly statechange: {
    readonly previous: StatsCollectorState;
    readonly current: StatsCollectorState;
  };
  readonly error: { readonly error: StatsCollectorError };
}
